import React, { useState } from 'react';
import confetti from 'canvas-confetti';
import playSound from '../../utils/playSound';

const REACTION_TYPES = [
  { type: 'like', emoji: '👍', sound: 'like.mp3' },
  { type: 'love', emoji: '❤️', sound: 'love.mp3' },
  { type: 'laugh', emoji: '😂', sound: 'laugh.mp3' },
  { type: 'wow', emoji: '😮', sound: 'wow.mp3' },
  { type: 'sad', emoji: '😢', sound: 'sad.mp3' },
  { type: 'angry', emoji: '😡', sound: 'angry.mp3' },
  { type: 'fire', emoji: '🔥', sound: 'fire.mp3' },
  { type: 'star', emoji: '⭐', sound: 'star.mp3' },
  { type: 'rocket', emoji: '🚀', sound: 'rocket.mp3' },
];

const ReactionBar = ({ post, currentPlayer, onReact }) => {
  const [isReacting, setIsReacting] = useState(false);

  const handleReact = async (type) => {
    setIsReacting(true);
    await onReact(type);
    confetti({ particleCount: 80, spread: 120 });
    playSound(`/sounds/${type}.mp3`, 4.8); // Use default sound for all reactions

    setTimeout(() => setIsReacting(false), 1200);
  };

  // Count reactions
  const reactionCounts = REACTION_TYPES.map((rt) => ({
    ...rt,
    count: post?.reactions?.filter((r) => r.type === rt.type).length,
    avatars: post?.reactions
      ?.filter((r) => r.type === rt.type)
      ?.map((r) => r.profilePhoto)
      ?.slice(0, 5),
    isMine: post?.reactions?.some(
      (r) => r.type === rt.type && r.playerId === currentPlayer.playerId,
    ),
  }));

  return (
    <div
      className="reaction-bar"
      style={{
        display: 'flex',
        gap: 7, // reduced from 12 to 7 for tighter spacing
        alignItems: 'center',
        margin: '12px 0',
        flexWrap: 'wrap', // ensures emojis wrap on small screens
      }}
    >
      {reactionCounts.map(({ type, emoji, count, avatars, isMine }) => (
        <div key={type} style={{ position: 'relative', cursor: 'pointer' }}>
          <span
            style={{
              fontSize: isMine ? 32 : 24,
              filter: isMine ? 'drop-shadow(0 0 8px #f59e42)' : '',
              transition: 'transform 0.2s',
              transform: isReacting && isMine ? 'scale(1.2)' : 'scale(1)',
            }}
            onClick={() => handleReact(type)}
            title={type.charAt(0).toUpperCase() + type.slice(1)}
          >
            {emoji}
          </span>
          {count > 0 && (
            <span style={{ fontSize: 14, fontWeight: 700, marginLeft: 2 }}>
              {count}
            </span>
          )}
          <div style={{ display: 'flex', gap: 2, marginTop: 2 }}>
            {avatars?.map((avatar, i) => (
              <img
                key={i}
                src={
                  avatar ||
                  'https://res.cloudinary.com/joegalaxy/image/upload/q_auto/v1656194537/Images/noAvatar_tsgpm9.png'
                }
                alt=""
                style={{ width: 18, height: 18, borderRadius: '50%' }}
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ReactionBar;
